import './App.scss';
import SLayout from './template/SLayout'
import { DefaultToastContainer, ToastProvider } from 'react-toast-notifications';

const ToastContainerOverride = (props: any) => (
  <DefaultToastContainer
    className="toast-container"
    style={{ zIndex: 1060 }}
    {...props}
  />
)

function App() {
  return (
    <ToastProvider autoDismiss autoDismissTimeout={6000} components={{ ToastContainer: ToastContainerOverride }}>
      <SLayout />
    </ToastProvider>
  )
}

export default App;
